import { useEffect, useState } from "react"

/**
 * Buchhaltungsadresse des Betriebs (#91, Entscheidung Paul 26.10.2026).
 *
 * Gesetzt → der Plan schlägt bei Lieferanten-Eingangsrechnungen den Schritt
 * „an Buchhaltung weiterleiten“ vor (ein Klick, keine Automatik). Leer → nie.
 * Eine einzelne Adresse: das Backend lehnt Namen, Listen und Suchbegriffe ab,
 * sonst verweigert der Mailserver die Weiterleitung (Gotcha PR #40).
 */
export function BuchhaltungAdresseCard({
  value, onSave,
}: {
  value: string
  onSave: (adresse: string) => Promise<void>
}) {
  const [adresse, setAdresse] = useState(value)
  const [saving, setSaving] = useState(false)
  useEffect(() => { setAdresse(value) }, [value])
  const dirty = adresse.trim() !== (value || "").trim()

  return (
    <div className="pp-card" style={{ padding: 18 }}>
      <div style={{ fontSize: 14, fontWeight: 500 }}>Buchhaltungsadresse</div>
      <div style={{ fontSize: 12, color: "var(--text-muted)", marginTop: 4, marginBottom: 12 }}>
        Ist eine Adresse hinterlegt, schlägt der Plan bei Rechnungen von Lieferanten
        „an Buchhaltung weiterleiten“ vor — ausgeführt wird erst mit Ihrem Klick.
        Eigene Rechnungskopien aus HERO bekommen den Schritt nicht. Leer = nie vorschlagen.
      </div>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <input
          type="email"
          aria-label="Buchhaltungsadresse"
          value={adresse}
          onChange={(e) => setAdresse(e.target.value)}
          placeholder="buchhaltung@firma.de"
          style={{ fontSize: 13, flex: 1 }}
        />
        <button
          type="button"
          disabled={!dirty || saving}
          onClick={async () => {
            setSaving(true)
            try { await onSave(adresse.trim()) } finally { setSaving(false) }
          }}
          className="pp-btn pp-btn-primary pp-btn-sm"
        >
          {saving ? "Speichert…" : "Speichern"}
        </button>
      </div>
    </div>
  )
}
